import Component from './DevRev.component';
import { connect } from 'react-redux';
import fromState from '/b2b/common/state/selectors';

const mapStateToProps = state => {
    const customerId = fromState.Auth.customer.getId(state);

    const userId = fromState.Auth.user.getId(state);
    const user = fromState.DB.user.getEntityById(state, userId);
    const { devRevToken = '' } = user || {};

    return {
        customerId,
        devRevToken,
    };
};

export default connect(mapStateToProps)(Component);
